import { render, staticRenderFns } from "./LoadoutCategories.vue?vue&type=template&id=fa224f20&scoped=true&"
import script from "./LoadoutCategories.vue?vue&type=script&lang=js&"
export * from "./LoadoutCategories.vue?vue&type=script&lang=js&"
import style0 from "./LoadoutCategories.vue?vue&type=style&index=0&id=fa224f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa224f20",
  null
  
)

component.options.__file = "LoadoutCategories.vue"
export default component.exports